import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: "removeimage",
})
export class RemoveImage implements PipeTransform {
  transform(content) {
    return content.replace(/<img[^>]*>/g, '');
  }
}
